.headerContainer {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  margin-top: 32px;
}

.headerContainer .textField {
  flex: 1;
}
